import { ReactElement } from 'react';
import cn from 'classnames';

import styles from './PriceDiscount.module.scss';
import config from '../../config.json';
import { formatPrice } from '../../utils/formatPrice';

import { Title } from '../Title/Title';
import { Paragraph } from '../Paragraph/Paragraph';
import { getDataTest } from '../../utils/dataTests';

export interface PriceDiscountProps {
    titleText: string;
    priceBefore?: number | string;
    priceAfter: number | string;
    suffix?: string;
    infoText?: string;
    className?: string;
    activated?: boolean;
}

export const PriceDiscount = ({
    titleText,
    priceBefore,
    priceAfter,
    suffix,
    infoText,
    className,
    activated = true,
    ...props
}: PriceDiscountProps): ReactElement | null => {
    return (
        <div className={styles.wrapper} {...props}>
            <Title className={styles.title} tag="h3" data-test={getDataTest(props, 'Title')}>
                {titleText}
            </Title>

            <div className={cn(styles.wrapper, className)} data-test={getDataTest(props, 'Price')}>
                {priceBefore && priceBefore < priceAfter && (
                    <div className={cn(styles.priceBefore, styles.price)} data-test={getDataTest(props, 'PriceBefore')}>
                        {formatPrice(priceBefore)}&nbsp;{config.CURRENCIES.CZK}
                        {suffix && ` / ${suffix}`}
                    </div>
                )}
                <div
                    className={cn(styles.priceAfter, styles.price, !activated && styles.notActivated)}
                    data-test={getDataTest(props, 'CurrentPrice')}
                >
                    {formatPrice(priceAfter)}&nbsp;{config.CURRENCIES.CZK}
                    {suffix && ` / ${suffix}`}
                </div>
            </div>

            {infoText && (
                <Paragraph className={cn(styles.infoText, 'mb-6')} data-test={getDataTest(props, 'InfoText')}>
                    {infoText}
                </Paragraph>
            )}
        </div>
    );
};
